import {
  AHButton,
  AHSeparator,
  Box,
  ColorType,
  Space,
  useLayoutContext,
} from "arkh";
import React, { useMemo } from "react";
import { useIntlTokens } from "./mobile/useIntlTokens";
import { View } from "react-native";
import { ModalTabletAwareKeyboardStickyView } from "./mobile/ModalTabletAwareKeyboardStickyView";

export function StepController({
  insets = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  ...props
}: {
  insets?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  color?: ColorType;
  disabled?: boolean;
  nextLoading?: boolean;
  create?: boolean;
  nextTitle?: string;
  disabledKeyboardHandling?: boolean;

  onNext?: () => void;
  onPrev?: () => void;
  space: Space;
}) {
  const layout = useLayoutContext();
  const padding = layout.space[props.space];

  const intl_tokens = useIntlTokens();

  const hasPrev = useMemo(() => !!props.onPrev, [props.onPrev]);
  const hasNext = useMemo(() => !!props.onNext, [props.onNext]);

  return (
    <>
      <View
        style={{
          height: insets.bottom + padding,
        }}
      ></View>
      <ModalTabletAwareKeyboardStickyView
        offset={{
          opened: -padding,
          closed: -insets.bottom - padding,
        }}
      >
        <Box
          color={props.color ?? "surface-primary"}
          insets={{ bottom: insets.bottom + padding }}
          style={{
            marginBottom: -insets.bottom - padding,
          }}
        >
          <AHSeparator />
          <Box
            style={[{ flexDirection: "row" }]}
            spaceHorizontal={props.space}
            spaceTop="small"
          >
            {hasPrev && props.onPrev ? (
              <Box style={{ flex: 2 }} spaceRight="medium">
                <AHButton
                  themeType="plain"
                  title={intl_tokens.Previous}
                  onPress={props.onPrev}
                />
              </Box>
            ) : null}
            <Box style={{ flex: 3 }}>
              {hasNext && props.onNext ? (
                <AHButton
                  themeType="primary"
                  title={
                    props.nextTitle !== undefined
                      ? props.nextTitle
                      : props.create
                        ? intl_tokens.Create
                        : intl_tokens.Next
                  }
                  onPress={props.onNext}
                  disabled={props.disabled ?? props.nextLoading}
                  loading={props.nextLoading}
                />
              ) : null}
            </Box>
          </Box>
        </Box>
      </ModalTabletAwareKeyboardStickyView>
    </>
  );
}
